import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { JuvareLogo } from '../../JuvareLogo';
import { themeColorsDark } from '../../JuvareTheme/colors/themeColorsDark';
import { useCommonWebTranslation } from '../../hooks';
/**
 * Renders a Juvare-themed icon button wrapped in a tooltip.
 *
 * @param {object} props - Component props.
 * @param {string} [props.href] - Optional URL the button links to.
 * @param {() => void} [props.onClick] - Optional click handler callback.
 *
 * @returns {JSX.Element} A tooltip-wrapped icon button with the Juvare logo.
 */
export const JuvareIconButton = (props) => {
    const { t } = useCommonWebTranslation();
    return (React.createElement(Tooltip, { title: t('globalHeader.otherJuvareSolutions') },
        React.createElement(IconButton, { size: 'large', sx: {
                mr: 1,
                // Global App header is always dark.
                color: themeColorsDark.icon.subtle,
                '&:hover': {
                    backgroundColor: themeColorsDark.overlay.hover,
                },
            }, href: props.href, onClick: props.onClick, "data-test": 'juvare-button' },
            React.createElement(Box, { sx: { width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                React.createElement(Box, { sx: { display: 'flex' } },
                    React.createElement(JuvareLogo, { size: 'lg' }))))));
};
